import Popup from '../utilities/Popup';

Popup.onShow('search', ($popup) => {
    setTimeout(() => {
        $popup.find('.city-search__input').focus();
    }, 700);
});
